import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";

export const ArticleCard = ({ a, index = 0, sectionName }) => {
  const img = a.infobox_image || a.hero_image;
  return (
    <Link
      to={`/wiki/${a.slug}`}
      data-testid={`article-card-${a.slug}`}
      style={{ animationDelay: `${Math.min(index, 12) * 60}ms` }}
      className={`group vellum rise lift flex flex-col theme-${a.theme || "neutral"}`}
    >
      <div className="aspect-[4/3] overflow-hidden border-b border-[#c9a227]/50 bg-[#ebe2cd] relative">
        {img ? (
          <img src={imgUrl(img)} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full grid place-items-center">
            <span className="font-display text-7xl text-[color:var(--accent)] drop-shadow-[2px_2px_0_#c9a227]">{a.title?.replace(/^(the|a|an)\s+/i, "").charAt(0)}</span>
          </div>
        )}
        <span className="absolute top-0 left-0 h-1 w-full bg-[color:var(--accent)]" />
      </div>
      <div className="p-5 flex-1">
        {sectionName && <p className="eyebrow mb-1">{sectionName}</p>}
        <h3 className="font-heading text-lg font-bold leading-snug text-[#2d1b0e] group-hover:text-[color:var(--accent)] transition-colors">{a.title}</h3>
        {a.summary && <p className="mt-2 text-[15px] leading-relaxed text-[#4a3a2a] line-clamp-3">{a.summary}</p>}
      </div>
    </Link>
  );
};
